(function() {
  function initInstantPage() {
    var hoverTimer;
    var lastTouchTime;
    var currentLink;
    var prefetchLink = document.createElement('link');
    var supportsPrefetch = prefetchLink.relList && prefetchLink.relList.supports && prefetchLink.relList.supports('prefetch');
    var saveData = navigator.connection && navigator.connection.saveData;
    var allowQueryString = 'instantAllowQueryString' in document.body.dataset;
    var allowExternalLinks = 'instantAllowExternalLinks' in document.body.dataset;
    var useWhitelist = 'instantWhitelist' in document.body.dataset;
    var delay = 65;
    var useMousedown = false;
    var touchOnly = false;

    if ('instantIntensity' in document.body.dataset) {
      if (document.body.dataset.instantIntensity.substr(0, 'mousedown'.length) === 'mousedown') {
        useMousedown = true;
        touchOnly = document.body.dataset.instantIntensity === 'mousedown-only';
      } else {
        var parsedDelay = parseInt(document.body.dataset.instantIntensity, 10);
        if (!isNaN(parsedDelay)) {
          delay = parsedDelay;
        }
      }
    }

    if (!supportsPrefetch || saveData) {
      return;
    }

    prefetchLink.rel = 'prefetch';
    document.head.appendChild(prefetchLink);

    function clearPrefetch() {
      prefetchLink.removeAttribute('href');
    }

    function prefetch(url) {
      prefetchLink.href = url;
    }

    function isPrefetchable(link) {
      return (
        link &&
        link.href &&
        currentLink !== link.href &&
        (!useWhitelist || 'instant' in link.dataset) &&
        (allowExternalLinks || link.origin === location.origin || 'instant' in link.dataset) &&
        ['http:', 'https:'].includes(link.protocol) &&
        (link.protocol !== 'http:' || location.protocol !== 'https:') &&
        (allowQueryString || !link.search || 'instant' in link.dataset) &&
        !(link.hash && link.pathname + link.search === location.pathname + location.search || 'noInstant' in link.dataset)
      );
    }

    function cancelTouchPrefetch() {
      currentLink = void 0;
      clearPrefetch();
    }

    function cancelHoverPrefetch(event) {
      if (event.relatedTarget && event.target.closest('a') === event.relatedTarget.closest('a')) {
        return;
      }

      if (hoverTimer) {
        clearTimeout(hoverTimer);
        hoverTimer = void 0;
      }

      currentLink = void 0;
      clearPrefetch();
    }

    if (!touchOnly) {
      document.addEventListener('touchstart', function(event) {
        lastTouchTime = performance.now();
        var link = event.target.closest('a');

        if (isPrefetchable(link)) {
          link.addEventListener('touchcancel', cancelTouchPrefetch, { once: true, passive: true });
          link.addEventListener('touchend', cancelTouchPrefetch, { once: true, passive: true });
          currentLink = link.href;
          prefetch(link.href);
        }
      }, { capture: true, passive: true });
    }

    if (useMousedown) {
      document.addEventListener('mousedown', function(event) {
        var link = event.target.closest('a');

        if (isPrefetchable(link)) {
          link.addEventListener('mouseout', cancelHoverPrefetch, { once: true });
          currentLink = link.href;
          prefetch(link.href);
        }
      }, { capture: true, passive: true });
      return;
    }

    document.addEventListener('mouseover', function(event) {
      if (performance.now() - lastTouchTime < 1100) {
        return;
      }

      var link = event.target.closest('a');

      if (isPrefetchable(link)) {
        link.addEventListener('mouseout', cancelHoverPrefetch, { once: true });
        currentLink = link.href;
        hoverTimer = setTimeout(function() {
          prefetch(link.href);
          hoverTimer = void 0;
        }, delay);
      }
    }, { capture: true, passive: true });
  }

  window.addEventListener('load', initInstantPage);
})();
